import { render, staticRenderFns } from "./OfferPrint.vue?vue&type=template&id=04008672&scoped=true"
import script from "./OfferPrint.vue?vue&type=script&lang=js"
export * from "./OfferPrint.vue?vue&type=script&lang=js"
import style0 from "./OfferPrint.vue?vue&type=style&index=0&id=04008672&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04008672",
  null
  
)

export default component.exports